// Tracking configuration.
// GA4 is live: the base tag loads from public/index.html on every page and
// SPA route changes fire page_view events from src/App.js.
// Google Ads conversions + Meta Pixel stay dormant until real IDs are provided.
// Measurement IDs are public identifiers; never place secrets in this file.
export const TRACKING_CONFIG = {
    calendly: {
        url: "https://calendly.com/niharikatalwar11/15min",
        enabled: true, // live — shows "Book an Intro Meeting" actions
    },
    google: {
        measurementId: "G-N0MPKPPGEF", // GA4, live via public/index.html
        adsId: "AW-18497655215", // live via public/index.html base tag
        adsConversionLabel: "", // label from the conversion action — add when provided
        enabled: false, // flip to true once adsId + adsConversionLabel are provided
    },
    meta: {
        pixelId: "", // Meta Pixel ID
        enabled: false, // flip to true once pixelId is set
    },
};
